import * as React from 'react';
export function useMessageBarBodyContextValues_unstable(state) {
    const link = React.useMemo(()=>({
            inline: true
        }), []);
    return {
        link
    };
}
